module.exports = __webpack_public_path__ + "img/onni.e6055073.svg";